import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        const $tp = $('.token-price');
        const xrate = parseInt($tp.data('xrate'), 10);
        const step = parseInt($tp.data('step'), 10);
        const maxqty = parseInt($tp.data('maxqty'), 10);

        let qty = 1;

        $('#qty_up').on('click', () => {
            qty += 1;

            if (qty === maxqty) {
                $('#qty_up').prop('disabled', true);
            }
            $('#qty_down').prop('disabled', false);

            this.update(qty, step, xrate);
        });

        $('#qty_down').on('click', () => {
            qty -= 1;

            $('#qty_up').prop('disabled', false);
            if (qty === 1) {
                $('#qty_down').prop('disabled', true);
            }

            this.update(qty, step, xrate);
        });
    }

    update(qty, step, xrate) {
        const $qty = $('#qty');
        const $price = $('#price');
        const $count = $('#token_count');

        $qty.val(qty);
        $price.text((qty * step).toFixed(2));
        $count.text(qty * step * xrate);
    }
}, ['purchase-tokens']);
